import React from 'react'

const color = props => {
  let color = props.appState.colorThemeString
  color = (color === 'theme-2' || color === 'theme-4') ? props.appState.colorTheme.level2 : props.appState.colorTheme.level1
  return <div className='color-block' style={{ background: color }} />
}

export default color